"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  TripRoad: ['trip-road', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.012,14.552a.239.239,0,0,0-.148-.137,1.969,1.969,0,0,1-.824-.52c-1.7-1.815-4.54-5.286-4.54-8.145,0-.171.009-.339.024-.506s.08-.494-.249-.494H12a.25.25,0,0,0-.25.25V7.75a.75.75,0,0,1-1.5,0V5A.25.25,0,0,0,10,4.75H7.181a.5.5,0,0,0-.465.317l-6.682,17A.5.5,0,0,0,.5,22.75H10a.25.25,0,0,0,.25-.25V19.75a.75.75,0,0,1,1.5,0V22.5a.25.25,0,0,0,.25.25h9.5a.5.5,0,0,0,.466-.683Zm-7.262,1.2a.75.75,0,0,1-1.5,0v-4a.75.75,0,0,1,1.5,0Z', 'M19.864,12.87C20.935,11.723,24,8.226,24,5.75a4.5,4.5,0,0,0-9,0c0,2.476,3.065,5.973,4.136,7.12A.5.5,0,0,0,19.864,12.87ZM18,5.75a1.5,1.5,0,1,1,1.5,1.5A1.5,1.5,0,0,1,18,5.75Z']],
  TripPinMultiple: ['trip-pin-multiple', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.75,12.25a6.255,6.255,0,0,1,4.611-6.031.5.5,0,0,0,.368-.443c.014-.174.021-.35.021-.526a5.25,5.25,0,0,0-10.5,0c0,2.39,1.4,4.32,2.63,6.02a14.28,14.28,0,0,1,1.58,2.513.5.5,0,0,1,.04.2v2.27a1,1,0,0,0,2,0v-.624a.5.5,0,0,0-.043-.2A7.809,7.809,0,0,1,5.75,12.25ZM3,5A2.5,2.5,0,1,1,5.5,7.5,2.5,2.5,0,0,1,3,5Z', 'M18.5,0a5.249,5.249,0,0,0-5.25,5.25c0,.176.007.352.021.526a.5.5,0,0,0,.368.443A6.255,6.255,0,0,1,18.25,12.25a7.809,7.809,0,0,1-.707,3.175.5.5,0,0,0-.043.2v.624a1,1,0,0,0,2,0V13.88a13.5,13.5,0,0,1,1.62-2.61c1.23-1.7,2.63-3.63,2.63-6.02A5.249,5.249,0,0,0,18.5,0Zm0,7.5A2.5,2.5,0,1,1,21,5,2.5,2.5,0,0,1,18.5,7.5Z', 'M12,7a5.256,5.256,0,0,0-5.25,5.25c0,2.387,1.4,4.319,2.634,6.024A13.386,13.386,0,0,1,11,20.885V23a1,1,0,0,0,2,0V20.885a13.386,13.386,0,0,1,1.616-2.611c1.235-1.705,2.634-3.637,2.634-6.024A5.256,5.256,0,0,0,12,7Zm0,7.5A2.5,2.5,0,1,1,14.5,12,2.5,2.5,0,0,1,12,14.5Z']],
  TripDistance: ['trip-distance', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.5,8.5A5.506,5.506,0,0,0,0,14c0,3.555,4.545,8.922,4.74,9.15a1,1,0,0,0,1.52,0C6.453,22.923,11,17.561,11,14A5.506,5.506,0,0,0,5.5,8.5Zm0,8A2.5,2.5,0,1,1,8,14,2.5,2.5,0,0,1,5.5,16.5Z', 'M19.5.5A4.505,4.505,0,0,0,15,5c0,3.171,3.978,7.185,4.146,7.354a.5.5,0,0,0,.708,0C20.022,12.185,24,8.171,24,5A4.505,4.505,0,0,0,19.5.5Zm0,6A1.5,1.5,0,1,1,21,5,1.5,1.5,0,0,1,19.5,6.5Z', 'M17.187,14.643l-7.2,6.22a1,1,0,0,0,1.307,1.514l7.2-6.221a1,1,0,1,0-1.306-1.513Z']],
  TripRoad1: ['trip-road-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.421,16.535a.5.5,0,0,0-.4-.3,1.707,1.707,0,0,1-1.008-.5c-.555-.554-5.153-5.264-5.7-9.238a.07.07,0,0,0-.139.01V9.48a.75.75,0,0,1-1.5,0v-2.6a.5.5,0,0,0-.5-.5H7.634A1.4,1.4,0,0,0,6.3,7.332L.067,22.143A1.422,1.422,0,0,0,1.423,24h7.75a.5.5,0,0,0,.5-.5V21.02a.75.75,0,0,1,1.5,0V23.5a.5.5,0,0,0,.5.5h7.75a1.42,1.42,0,0,0,1.339-1.9Zm-7.248.33a.75.75,0,0,1-1.5,0v-3.23a.75.75,0,0,1,1.5,0Z', 'M18.25,15a.5.5,0,0,0,.354-.146c.22-.221,5.4-5.439,5.4-9.1a5.75,5.75,0,0,0-11.5,0c0,3.665,5.176,8.883,5.4,9.1A.5.5,0,0,0,18.25,15Zm-2-9.25a2,2,0,1,1,2,2A2,2,0,0,1,16.25,5.75Z']],
  TripRoadCircle: ['trip-road-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.887,13a.5.5,0,0,0,.353-.146c.185-.185,4.51-4.55,4.51-7.991a4.864,4.864,0,0,0-9.728,0c0,3.441,4.327,7.806,4.511,7.991A.5.5,0,0,0,18.887,13ZM17.25,4.864A1.637,1.637,0,1,1,18.886,6.5,1.637,1.637,0,0,1,17.25,4.864Z', 'M19.149,14.481a1.767,1.767,0,0,1-.262.019,2,2,0,0,1-1.414-.586c-2.108-2.105-4.739-5.673-4.937-8.709a.5.5,0,0,0-.387-.455A9.573,9.573,0,0,0,10,4.5,9.739,9.739,0,0,0,.8,17.477a.5.5,0,0,0,.8.211c.4-.351.8-.676,1.187-.959a.75.75,0,0,1,.889,1.209,19.8,19.8,0,0,0-1.552,1.285.5.5,0,0,0-.071.66,9.739,9.739,0,0,0,17.662-4.867.5.5,0,0,0-.569-.535ZM9.6,16.134a5.769,5.769,0,0,0-1.084-.1h0a5.875,5.875,0,0,0-1.548.211.739.739,0,0,1-.2.026.75.75,0,0,1-.2-1.474,7.443,7.443,0,0,1,1.939-.263h0a7.365,7.365,0,0,1,1.361.129A.75.75,0,1,1,9.6,16.134Zm7.283,2.2a.752.752,0,0,1-.715.522.762.762,0,0,1-.228-.035,18.193,18.193,0,0,1-2.827-1.269.762.762,0,0,1-.331-1.018.739.739,0,0,1,1-.325l.023.012A16.812,16.812,0,0,0,16.4,17.4.75.75,0,0,1,16.885,18.337Z']],
  TripPins: ['trip-pins', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.5,12.333a.5.5,0,0,0,.354-.146C5.022,12.017,9,8.008,9,5.167a4.5,4.5,0,0,0-9,0c0,2.841,3.978,6.85,4.146,7.02A.5.5,0,0,0,4.5,12.333ZM2.694,5.167A1.584,1.584,0,1,1,4.277,6.75,1.585,1.585,0,0,1,2.694,5.167Z', 'M19,10.333a5.006,5.006,0,0,0-5,5C14,18.5,18.457,23,18.646,23.187a.5.5,0,0,0,.708,0C19.543,23,24,18.5,24,15.333A5.006,5.006,0,0,0,19,10.333Zm0,6.75a1.75,1.75,0,1,1,1.75-1.75A1.751,1.751,0,0,1,19,17.083Z', 'M4.5,13.833a1,1,0,0,0-1,1v1.5a1,1,0,0,0,2,0v-1.5A1,1,0,0,0,4.5,13.833Z', 'M4.5,18.833a1,1,0,0,0-1,1v1.5a1,1,0,0,0,2,0v-1.5A1,1,0,0,0,4.5,18.833Z', 'M9.5,20.333H8a1,1,0,0,0,0,2H9.5a1,1,0,0,0,0-2Z', 'M14.5,20.333H13a1,1,0,0,0,0,2h1.5a1,1,0,0,0,0-2Z']],
  TripMultipleDestination: ['trip-multiple-destination', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.346,17.165,7.079,22.139a.989.989,0,1,0,.935,1.743l9.268-4.973a.99.99,0,1,0-.936-1.744Z', 'M11.956,11.838a.989.989,0,0,0,.093,1.4l2.487,2.177a.99.99,0,0,0,1.3-1.49l-2.487-2.176A.99.99,0,0,0,11.956,11.838Z', 'M19.918,6.433a3.963,3.963,0,0,0-3.959,3.959c0,2.648,3.461,6.14,3.609,6.288a.494.494,0,0,0,.7,0c.148-.148,3.609-3.64,3.609-6.288A3.963,3.963,0,0,0,19.918,6.433Zm0,5.443A1.485,1.485,0,1,1,21.4,10.392,1.484,1.484,0,0,1,19.918,11.876Z', 'M11.01,10.392a.5.5,0,0,0,.35-.145c.148-.148,3.609-3.64,3.609-6.288a3.959,3.959,0,1,0-7.917,0c0,2.648,3.461,6.14,3.608,6.288A.5.5,0,0,0,11.01,10.392ZM9.526,3.959A1.485,1.485,0,1,1,11.01,5.443,1.484,1.484,0,0,1,9.526,3.959Z', 'M9.031,14.351a4.454,4.454,0,1,0-8.907,0c0,1.892,1.054,3.342,2.074,4.744.969,1.333,1.884,2.592,1.884,4.163a.5.5,0,1,0,.99,0c0-1.571.915-2.83,1.885-4.163C7.976,17.693,9.031,16.243,9.031,14.351ZM4.577,15.835a1.98,1.98,0,1,1,1.98-1.979A1.982,1.982,0,0,1,4.577,15.835Z']],
  TripDestination: ['trip-destination', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.5,21h0a1,1,0,0,0,.761-.351C6.454,20.423,11,15.057,11,11.5a5.5,5.5,0,0,0-11,0c0,3.558,4.545,8.922,4.739,9.149A1,1,0,0,0,5.5,21ZM3,11.5A2.5,2.5,0,1,1,5.5,14,2.5,2.5,0,0,1,3,11.5Z', 'M19.5,13H15a2,2,0,0,0-2,2v6.75a.25.25,0,0,1-.25.25H5.5a1,1,0,0,0,0,2H13a2,2,0,0,0,2-2V15.25a.25.25,0,0,1,.25-.25H19.5a1,1,0,0,0,0-2Z', 'M19.5,12a.5.5,0,0,0,.354-.146C20.023,11.684,24,7.671,24,4.5a4.5,4.5,0,0,0-9,0c0,3.171,3.977,7.184,4.146,7.354A.5.5,0,0,0,19.5,12ZM18,4.5A1.5,1.5,0,1,1,19.5,6,1.5,1.5,0,0,1,18,4.5Z']]
};
exports["default"] = _default;